<template>
  <section class="s-team">
    <h2>People</h2>
    <div class="team-container">
      <div class="team-item">
        <img src="/img/fabrizio_serri.png" alt="Fabrizio Serri" />
        <strong>Fabrizio Serri</strong>
        <p>CEO & Owner in Adtelier </p>
      </div>
      <!-- <div class="team-item">
        <img src="/img/elisabetta_tadiello.png" alt="Elisabetta Tadiello" />
        <strong>Elisabetta Tadiello</strong>
        <p>Managing Director in Address + Managing Director in Adtelier</p>
      </div> -->
      <div class="team-item">
        <img src="/img/alessio_di_bartolo.png" alt="Alessio Di Bartolo" />
        <strong>Alessio Di Bartolo</strong>
        <p>Managing Director in Digital Address + Head of Digital in Adtelier </p>
      </div>
      <div class="team-item">
        <img src="/img/franco_ercolini.png" alt="Franco Ercolini" />
        <strong>Franco Ercolini</strong>
        <p>Managing Director in Adextra + Partner in Address </p>
      </div>
      <div class="team-item">
        <img src="/img/loredana_la_marca.png" alt="Loredana La Marca" />
        <strong>Loredana La Marca</strong>
        <p>CFO in Adtelier</p>
      </div>
      <div class="team-item">
        <img src="/img/chiara_bartolini.png" alt="Chiara Bartolini" />
        <strong>Chiara Bartolini</strong>
        <p>Media Director</p>
      </div>
      <!-- <div class="team-item">
        <img src="/img/margherita_bourtsev.png" alt="Margherita Bourtsev" />
        <strong>Margherita Bourtsev</strong>
        <p>Planner</p>
      </div> -->
      <div class="team-item">
        <img src="/img/lucia_guarino.png" alt="Lucia Guarino" />
        <strong>Lucia Guarino</strong>
        <p>Media Director</p>
      </div>
      <div class="team-item">
        <img src="/img/alice_giussani.png" alt="Alice Giussani" />
        <strong>Alice Giussani</strong>
        <p>Senior Planner</p>
      </div>
      <div class="team-item">
        <img src="/img/dino_ceschia.png" alt="Dino Ceschia" />
        <strong>Dino Ceschia</strong>
        <p>Planner</p>
      </div>
      <div class="team-item">
        <img src="/img/barbara_provvisionato.png" alt="Barbara Provvisionato" />
        <strong>Barbara Provvisionato</strong>
        <p>Media Director</p>
      </div>
      <div class="team-item">
        <img src="/img/maria_luisa_gerosa.png" alt="Maria Luisa Gerosa" />
        <strong>Maria Luisa Gerosa</strong>
        <p>Media Manager</p>
      </div>
      <div class="team-item">
        <img src="/img/laura_bettinelli.png" alt="Laura Bettinelli" />
        <strong>Laura Bettinelli</strong>
        <p>Senior Planner</p>
      </div>
      <div class="team-item">
        <img src="/img/manuela_collesei.png" alt="Manuela Collesei" />
        <strong>Manuela Collesei</strong>
        <p>Media Director</p>
      </div>
      <div class="team-item">
        <img src="/img/laura_delle_piagge.png" alt="Laura Delle Piagge" />
        <strong>Laura Delle Piagge</strong>
        <p>Senior Planner</p>
      </div>
      <div class="team-item">
        <img src="/img/elisa_tonali.png" alt="Elisa Tonali" />
        <strong>Elisa Tonali</strong>
        <p>Senior Planner</p>
      </div>
      <div class="team-item">
        <img src="/img/chiara_varetto.png" alt="Chiara Varetto" />
        <strong>Chiara Varetto</strong>
        <p>CEO Assistant & Office Manager</p>
      </div>
      <div class="team-item">
        <img src="/img/paolo_giorgetti.png" alt="Paolo Giorgetti" />
        <strong>Paolo Giorgetti</strong>
        <p>Business Developer</p>
      </div>
      <div class="team-item">
        <img src="/img/gianpio_gravina.png" alt="Gianpio Gravina" />
        <strong>Gianpio Gravina</strong>
        <p>Head of AD Technologies</p>
      </div>
      <div class="team-item">
        <img src="/img/marta_francavilla.png" alt="Marta Francavilla" />
        <strong>Marta Francavilla</strong>
        <p>Digital Director</p>
      </div>
      <div class="team-item">
        <img src="/img/fabio_scotti.png" alt="Fabio Scotti" />
        <strong>Fabio Scotti</strong>
        <p>Digital Director</p>
      </div>
      <div class="team-item">
        <img src="/img/irene_volpe.png" alt="Irene Volpe" />
        <strong>Irene Volpe</strong>
        <p>Head of Operations</p>
      </div>
      <div class="team-item">
        <img src="/img/chiara_costa.png" alt="Chiara Costa " />
        <strong>Chiara Costa </strong>
        <p>Senior Account and Business Developer</p>
      </div>
      <div class="team-item">
        <img src="/img/chiara_borgini.png" alt="Chiara Borgini " />
        <strong>Chiara Borgini </strong>
        <p>Digital Project Manager</p>
      </div>
      <!-- <div class="team-item">
        <img src="/img/sara_colzani.png" alt="Sara Colzani" />
        <strong>Sara Colzani</strong>
        <p>Senior Social Media Strategist</p>
      </div> -->
      <div class="team-item">
        <img src="/img/silvia_ferrarotti.png" alt="Silvia Ferrarotti" />
        <strong>Silvia Ferrarotti</strong>
        <p>Digital Planner / Social Media Specialist</p>
      </div>
      <div class="team-item">
        <img src="/img/giuseppe_saporito.png" alt="Giuseppe Saporito" />
        <strong>Giuseppe Saporito</strong>
        <p>Digital Account</p>
      </div>
      <div class="team-item">
        <img src="/img/chiara_mariani.png" alt="Chiara Mariani" />
        <strong>Chiara Mariani</strong>
        <p>Senior Web Trafficker / Data Specialist</p>
      </div>
      <div class="team-item">
        <img src="/img/federico_albanese.png" alt="Federico Albanese" />
        <strong>Federico Albanese</strong>
        <p>IT and SEO Specialist / Senior Web Trafficker </p>
      </div>
      <div class="team-item">
        <img src="/img/ilaria_ingraffia.png" alt="Ilaria Ingraffia" />
        <strong>Ilaria Ingraffia</strong>
        <p>Biddable Specialist</p>
      </div>
      <div class="team-item">
        <img src="/img/silvia_amore.png" alt="Silvia Amore" />
        <strong>Silvia Amore</strong>
        <p>Senior Digital Account</p>
      </div>
      <div class="team-item">
        <img src="/img/martina_tardivo.png" alt="Name" />
        <strong>Martina Tardivo</strong>
        <p>Digital Performance Account</p>
      </div>
      <div class="team-item">
        <img src="/img/marisa_fumagalli.png" alt="Name" />
        <strong>Marisa Fumagalli</strong>
        <p>Head of OOH & Unconventional </p>
      </div>
      <div class="team-item">
        <img src="/img/renata_bianchi.png" alt="Renata Bianchi" />
        <strong>Renata Bianchi</strong>
        <p>OOH & Unconventional Manager</p>
      </div>
      <div class="team-item">
        <img src="/img/marcello_rolandi.png" alt="Marcello Rolandi" />
        <strong>Marcello Rolandi</strong>
        <p>Head of Intelligence & Buying Support Research </p>
      </div>
      <div class="team-item">
        <img src="/img/francesca_saporito.png" alt="Francesca Saporito" />
        <strong>Francesca Saporito</strong>
        <p>Head of Strategic Support Research</p>
      </div>
      <div class="team-item">
        <img src="/img/giorgio_vittorio_da_pos.png" alt="Giorgio Vittorio Da Pos" />
        <strong>Giorgio Vittorio Da Pos</strong>
        <p>Research Consultant </p>
      </div>
      <div class="team-item">
        <img src="/img/valentina_bresnaider.png" alt="Valentina Bresnaider" />
        <strong>Valentina Bresnaider</strong>
        <p>Administrative</p>
      </div>
      <div class="team-item">
        <img src="/img/chiara_pochetti.png" alt="Chiara Pochetti" />
        <strong>Chiara Pochetti</strong>
        <p>Administrative</p>
      </div>
      <div class="team-item">
        <img src="/img/claudia_marchetti.png" alt="Claudia Marchetti" />
        <strong>Claudia Marchetti</strong>
        <p>Administrative</p>
      </div>
      <div class="team-item">
        <img src="/img/valentina_leoni.png" alt="Valentina Leoni" />
        <strong>Valentina Leoni</strong>
        <p>Administrative</p>
      </div>
    </div>
  </section>
</template>

<script>
import Team from './team';

let team;

export default {
  mounted() {
    team = new Team();
    team.init();
  },
  destroyed() {
    team.destroy();
  },
};
</script>
